import "core-js/modules/es.regexp.exec.js";
export let Category = /*#__PURE__*/function (Category) {
  Category["search"] = "Search";
  Category["launch"] = "Launch";
  Category["help"] = "Help";
  Category["timeLine"] = "Time line";
  Category["view"] = "View";
  Category["dataSource"] = "Data Source";
  Category["dataTab"] = "Data tab";
  Category["addDataUrl"] = "Add data Url";
  Category["guide"] = "Guide";
  Category["share"] = "Share";
  Category["story"] = "Story";
  return Category;
}({});
export let SearchAction = /*#__PURE__*/function (SearchAction) {
  SearchAction["bing"] = "Bing";
  SearchAction["catalog"] = "Catalog";
  SearchAction["gazetteer"] = "Gazetteer";
  SearchAction["nominatim"] = "nominatim";
  SearchAction["cesium"] = "Cesium";
  SearchAction["mapbox"] = "Mapbox";
  return SearchAction;
}({});
export let LaunchAction = /*#__PURE__*/function (LaunchAction) {
  LaunchAction["url"] = "url";
  return LaunchAction;
}({});
export let HelpAction = /*#__PURE__*/function (HelpAction) {
  HelpAction["panelOpened"] = "Panel opened";
  HelpAction["takeTour"] = "Take tour";
  return HelpAction;
}({});
export let TimeLineAction = /*#__PURE__*/function (TimeLineAction) {
  TimeLineAction["goToStart"] = "Go to start";
  TimeLineAction["togglePlay"] = "Toggle play";
  TimeLineAction["playSlower"] = "Play slower";
  TimeLineAction["playFaster"] = "Play faster";
  TimeLineAction["toggleLoop"] = "Toggle loop";
  return TimeLineAction;
}({});
export let ViewAction = /*#__PURE__*/function (ViewAction) {
  ViewAction["zoomIn"] = "Zoom in";
  ViewAction["zoomOut"] = "Zoom out";
  ViewAction["reset"] = "Reset";
  ViewAction["enterFullScreen"] = "Enter full screen";
  ViewAction["exitFullScreen"] = "Exit full screen";
  return ViewAction;
}({});
export let DataSourceAction = /*#__PURE__*/function (DataSourceAction) {
  DataSourceAction["addFromCatalogue"] = "Add from catalogue";
  DataSourceAction["removeFromCatalogue"] = "Remove from catalogue";
  DataSourceAction["addFromPreviewButton"] = "Add from preview button";
  DataSourceAction["removeFromPreviewButton"] = "Remove from preview button";
  DataSourceAction["removeFromWorkbench"] = "Remove from workbench";
  DataSourceAction["removeAllFromWorkbench"] = "Remove all from workbench";
  DataSourceAction["addFromDragAndDrop"] = "Add from Drag and Drop";
  DataSourceAction["addFromShareOrInit"] = "Add from share or init source";
  DataSourceAction["addDisplayGroupFromCatalogue"] = "Add display group from catalogue";
  DataSourceAction["removeDisplayGroupFromCatalogue"] = "Remove display group from catalogue";
  DataSourceAction["addDisplayGroupFromAddAllButton"] = "Add display group via Add All button";
  DataSourceAction["removeDisplayGroupFromRemoveAllButton"] = "Remove display group via Remove All button";
  return DataSourceAction;
}({});
export let DatatabAction = /*#__PURE__*/function (DatatabAction) {
  DatatabAction["addDataUrl"] = "Add data url";
  return DatatabAction;
}({});
export let GuideAction = /*#__PURE__*/function (GuideAction) {
  GuideAction["open"] = "open";
  GuideAction["close"] = "close";
  GuideAction["openInModal"] = "open (inside modal)";
  GuideAction["closeInModal"] = "close (inside modal)";
  GuideAction["navigatePrev"] = "Navigate previous";
  GuideAction["navigateNext"] = "Navigate next";
  return GuideAction;
}({});
export let ShareAction = /*#__PURE__*/function (ShareAction) {
  ShareAction["storyCopy"] = "Story copy url";
  ShareAction["catalogCopy"] = "Catalogue copy";
  ShareAction["shareCopy"] = "Share copy";
  return ShareAction;
}({});
export let StoryAction = /*#__PURE__*/function (StoryAction) {
  StoryAction["saveStory"] = "save story";
  StoryAction["runStory"] = "run story";
  StoryAction["viewScene"] = "view scene";
  StoryAction["datasetView"] = "dataset view";
  return StoryAction;
}({});